import Register from '@/components/account/register';
import Login from '@/components/account/login';
import Reset from '@/components/account/reset';
import Users from '@/components/account/user-list';
import UserUpdate from '@/components/account/user-update';

const routes = [
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Technicians',
                    to: { name: 'users' }
                },
                { text: 'Create' }
			],
			requiresAuth: true
        }
	},
	
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            breadcrumb: [
               
                { text: 'Login' }
            ]
        }
	},

	{
        path: '/reset/:id',
        name: 'reset',
        component: Reset,
        meta: {
            breadcrumb: [
                {
                    text: 'Login',
                    to: { name: 'login' }
                },
                { text: 'Reset password' }
            ]
        }
	},
	


    {
        path: '/users',
        name: 'users',
        component: Users,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Technicians' }
            ],
			requiresAuth: true
        }
    },
    {
        path: '/users/:id/update',
        name: 'userupdate',
        component: UserUpdate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Technicians',
                    to: { name: 'users' }
                },
                { text: 'Edit' }
            ],
			requiresAuth: true
        }
    },   


];

export default routes;


// WEBPACK FOOTER //
// ./src/components/account/routes/index.js